module.exports = __webpack_public_path__ + "img/bio_b_500.da6a95cd.png";